import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, IconButton, Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info'; // InfoIcon for view action

const CategoryTable = ({ categories, page, limit, onUpdate, onDelete, onView }) => (
  <TableContainer component={Paper}>
    <Table>
     <TableHead sx={{ backgroundColor: '#1976d2' }}>
  <TableRow>
    <TableCell sx={{ color: '#fff' }}><strong>Sr.No.</strong></TableCell>
    <TableCell sx={{ color: '#fff' }}><strong>ID</strong></TableCell>
    <TableCell sx={{ color: '#fff' }}><strong>Type</strong></TableCell>
    <TableCell sx={{ color: '#fff' }}><strong>Actions</strong></TableCell>
  </TableRow>
</TableHead>
      <TableBody>
        {categories.map((type, index) => {
          if (!type || !type.id) return null;

          return (
            <TableRow key={type.id}>
              <TableCell>{(page - 1) * limit + index + 1}</TableCell>
              <TableCell>{type.id}</TableCell>
              <TableCell>{type.type_name}</TableCell>
              <TableCell>
                <Tooltip title="View Info" arrow>
                  <IconButton color="info" onClick={() => onView(type)}>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Edit Category" arrow>
                  <IconButton color="primary" onClick={() => onUpdate(type)}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete Category" arrow>
                  <IconButton color="error" onClick={() => onDelete(type.id)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);

export default CategoryTable;
